import { useDispatch } from 'react-redux';
import { useAppSelector } from 'src/stores';
import { IProvince } from 'src/types';
import { setAreaActive, setListArea } from './area.slice';

export default function useAreaStore() {
  const dispatch = useDispatch();
  const area = useAppSelector((state) => state.area);

  const changeListArea = (data: IProvince[]) => {
    dispatch(setListArea(data));
  };

  const changeAreaActive = (data: { active: string; activeName: string }) => {
    dispatch(setAreaActive(data));
  };

  return {
    area,
    changeListArea,
    changeAreaActive,
  };
}
